import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import contactNoteDialogService from 'services/contactNoteDialogService';
import { ClientRepItem } from 'types/LegalPartner';

export const useGetBRLinkedClientRepresentatives = (id: string, usedInBr: boolean) => {
  return useQuery<ClientRepItem[], AxiosError>({
    queryKey: ['useGetBRLinkedClientRepresentatives', id],
    queryFn: () => contactNoteDialogService.getBRLinkedClientRepresentatives(id),
    select: (data) => {
      return data.map((item) => ({ ...item, dateOfOrigin: item?.dateOfOrigin?.split('-').join('') }));
    },
    enabled: id.length > 0 && usedInBr,
  });
};
